import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getFinancialReport } from '@/utils/report';

export const procedureReportFinancialRoute: RouteConfig = {
  path: 'reports/financial',
  name: 'procedureReportFinancial',
  component: () =>
    import(/* webpackChunkName: "ReportFinancial" */ '@/views/mainRoute/procedure/details/ReportFinancial.vue'),
  beforeEnter: (to, from, next) => {
    getFinancialReport(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
